module.exports = __webpack_public_path__ + "img/AI0036.8212c66.webp";